import { render, staticRenderFns } from "./JdSkuInfoCard_ForUser.vue?vue&type=template&id=1036ef0c&scoped=true&"
import script from "./JdSkuInfoCard_ForUser.vue?vue&type=script&lang=js&"
export * from "./JdSkuInfoCard_ForUser.vue?vue&type=script&lang=js&"
import style0 from "./JdSkuInfoCard_ForUser.vue?vue&type=style&index=0&id=1036ef0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1036ef0c",
  null
  
)

export default component.exports